import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InsuranceLogo from "../../assets/svg/insure.svg";
import WellnessLogo from "../../assets/svg/wellness.svg";
import HospicashLogo from "../../assets/svg/hospicash.svg";
import PercentIcon from "../../assets/svg/percent.svg";
import CrossedIcon from "../../assets/svg/crossed.svg";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import axios from "axios";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid #EAECF0`,
  borderRadius: "20px",
  padding: "12px 19px",
  marginBottom: "14px",
  color: "#2A3140",
  "&::before": {
    display: "none",
  },
  [theme.breakpoints.down("md")]: {
    border: "none",
    borderBottom: `1px solid #EAECF0`,
    borderRadius: "0px",
    padding: "0",
    margin: "0",
    "&:last-child": {
      borderBottom: 0,
    },
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    margin: "0",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  borderTop: "1px solid #EAECF0",
  padding: "0",
  [theme.breakpoints.down("md")]: {
    borderTop: "none",
    padding: "0 10px",
  },
}));
const KeyBenfits = () => {
  const [expanded, setExpanded] = React.useState<string | false>("panel2");
  const [windowWidth, setWindowWidth] = useState<number>(0);
  useEffect(() => {
    // Access the window object only on the client side
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Set the initial width
    handleResize();

    // Add event listener to update width on window resize
    window.addEventListener("resize", handleResize);

    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

    useEffect(()=>{
      if(windowWidth < 1000){
        setExpanded(false)
      }else{
        setExpanded("panel2")
      }
    },[windowWidth])
  return (
    <>
      <div className="lg:text-[46px] lg:leading-[59px] text-text-color-6 font-extrabold lg:font-bold text-[14px] leading-[18px] text-center lg:text-start">
        Key benefits
      </div>
      <div className="rounded-[20px] border-[1px] lg:border-[0px] lg:rounded-[0] border-text-color-4 p-[12px] lg:p-0 mt-[19px] lg:mt-[50px]">
        {/* <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
          className="shadow-none"
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            style={{ padding: "0", margin: "0" }}
          >
            <div className="lg:text-[18px] lg:leading-[18px] text-text-color-6 font-bold lg:font-semibold text-[12px] leading-[18px] flex items-center">
              <img
                className="mr-[18px]"
                src={InsuranceLogo}
                alt="InsuranceLogo"
              />
              CoverSure Platform
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="lg:mt-[15px] list-disc list-inside mb-[16px]">
              <li className="text-[12px] leading-[20px] lg:text-[16px] lg:leading-[23px] font-normal text-text-color-1">
                Simplify and manage all your insurance policies —life, health,
                motor, and more—in one place. Share them with your family in
                just a click!
              </li>
              <li className="text-[12px] leading-[20px] lg:text-[16px] lg:leading-[23px] font-normal text-text-color-1 lg:mt-[10px]">
                Easily renew your existing insurance policies and get quick,
                hassle-free claims support.
              </li>
              <li className="text-[12px] leading-[20px] lg:text-[16px] lg:leading-[23px] font-normal text-text-color-1 lg:mt-[10px]">
                Unlock more with CoverSure: Pay bills effortlessly, access
                emergency vehicle services, discover the right insurance
                coverage and more!
              </li>
            </ul>
          </AccordionDetails>
        </Accordion> */}
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            style={{ padding: "0", margin: "0" }}
          >
            <div className="lg:text-[18px] lg:leading-[18px] text-text-color-6 font-bold lg:font-semibold text-[12px] leading-[18px] flex items-center">
              <img
                className="mr-[18px]"
                src={WellnessLogo}
                alt="WellnessLogo"
              />
              Wellness Benefits
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Teleconsultations
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Unlimited doctor consultations by phone for 12 months
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Nutrition
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                4 virtual sessions with a nutrition coach
              </div>
            </div>
            <div className="w-[100%] flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Discounts
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Discounts on medicines and lab tests
              </div>
            </div>
          </AccordionDetails>
        </Accordion>
        {/* <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            style={{ padding: "0", margin: "0" }}
          >
            <div className="lg:text-[18px] lg:leading-[18px] text-text-color-6 font-bold lg:font-semibold text-[12px] leading-[18px] flex items-center">
              <img
                className="mr-[18px]"
                src={HospicashLogo}
                alt="HospicashLogo"
              />
              Hospicash Insurance Coverages
            </div>
          </AccordionSummary>
          <AccordionDetails>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Policy Period
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                1 Year
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Age Limit
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Min.18 years | Max. 65 years
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Coverage
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Accidental Hospitalization Cash Allowance
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Per Day Amount
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                ₹500
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Maximum Days Covered
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                30 Days
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                ICU Amount
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                ₹1000
              </div>
            </div>
            <div className="w-[100%] border-b-[1px] border-text-color-4 flex item-center py-[16px]">
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                Initial Waiting Period
              </div>
              <div className="w-1/2 text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px]">
                30 Days
              </div>
            </div>
            <div className="w-[100%] flex item-center py-[16px]">
              <div className="w-1/2">
                <div
                  className="text-[11px] leading-[18px] lg:text-[15px] lg:leading-[26px] bg-bg-color-1 text-text-color-2 py-[6px] px-[16px] lg:py-[10px] lg:px-[30px] rounded-[16px] w-fit font-semibold mr-[5px] cursor-pointer"
                  onClick={async () => {
                    try {
                      // Fetch the file from S3
                      const response = await axios.get(
                        "https://app-prod-public.s3.ap-south-1.amazonaws.com/prosure/Policy_Brochure.pdf",
                        {
                          responseType: "blob", // Important for downloading files
                        }
                      );

                      // Create a URL for the file blob
                      const blob = new Blob([response.data], {
                        type: "application/pdf",
                      });
                      const link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = "Policy-Brochure.pdf"; // Specify the file name for download
                      link.click();

                      // Clean up the URL object
                      window.URL.revokeObjectURL(link.href);
                    } catch (error) {
                      console.error("Error downloading the file", error);
                    }
                  }}
                >
                  Policy Brochure
                </div>
              </div>
              <div className="w-1/2">
                <div
                  className="text-[11px] leading-[18px] lg:text-[15px] lg:leading-[26px] bg-bg-color-1 text-text-color-2 py-[6px] px-[16px] lg:py-[10px] lg:px-[30px] rounded-[16px] w-fit font-semibold cursor-pointer"
                  onClick={async () => {
                    try {
                      // Fetch the file from S3
                      const response = await axios.get(
                        "https://app-prod-public.s3.ap-south-1.amazonaws.com/prosure/Terms-and-Conditions.pdf",
                        {
                          responseType: "blob", // Important for downloading files
                        }
                      );

                      // Create a URL for the file blob
                      const blob = new Blob([response.data], {
                        type: "application/pdf",
                      });
                      const link = document.createElement("a");
                      link.href = window.URL.createObjectURL(blob);
                      link.download = "Terms-And-Conditions.pdf"; // Specify the file name for download
                      link.click();

                      // Clean up the URL object
                      window.URL.revokeObjectURL(link.href);
                    } catch (error) {
                      console.error("Error downloading the file", error);
                    }
                  }}
                >
                  Terms and conditions
                </div>
              </div>
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[16px] lg:leading-[21px] font-bold mt-[20px] flex items-center mb-[12px] lg:mb-[20px]">
              <img src={CrossedIcon} alt="CrossedIcon" className="mr-[10px]" />
              Exclusions
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px] border-b-[1px] border-text-color-4 pb-[16px] lg:pb-[20px]">
              Individual involved in hazardous activities, such as working with
              explosives, underground mines, or involving electrical
              installation with high tension supply, etc.
            </div>
            <div className="text-[12px] leading-[18px] lg:text-[16px] lg:leading-[26px] p-[8px] bg-text-color-4 mt-[16px] lg:mt-[21px] rounded-[10px]">
              Hospital Cash Cover is provided by CoverSure in partnership with
              Go Digit General Insurance Limited under Digit Group Hospital Cash
              Policy and UIN GODHLGP21147V012021
            </div>
          </AccordionDetails>
        </Accordion> */}
      </div>
    </>
  );
};

export default KeyBenfits;
